import { render, staticRenderFns } from "./ModalAddBodyPart.vue?vue&type=template&id=2bfc1cbe"
import script from "./ModalAddBodyPart.vue?vue&type=script&lang=js"
export * from "./ModalAddBodyPart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports